<div class="editor-header" *ngIf="!isViewAll">
    <div nz-row>
        <div nz-col nzSpan="12" class="d-flex justify-content-around align-items-center">
            <span nz-icon nzType="column-width" nzTheme="outline"></span>
            <input [ngModel]="class['range-price']['width'] | vhnumber"
                (ngModelChange)="class['range-price']['width'] = $event + 'px'" (blur)="updateClass()" type="number"
                style="width: 70%;background-color: transparent;border: none;" />
        </div>
        <div nz-col nzSpan="12" class="d-flex justify-content-around align-items-center">
            <span nz-icon nzType="column-height" nzTheme="outline"></span>
            <input [ngModel]="class['range-price']['height']  | vhnumber"
                (ngModelChange)="class['range-price']['height'] = $event + 'px'" (blur)="updateClass()" type="number"
                style="width: 70%;background-color: transparent;border: none;" />
        </div>
    </div>
    <ul nz-menu nzMode="inline" >
        <!-- Chọn kiểu hiển thị của object -->
        <li nz-submenu nzTitle="{{'chon_kieu_hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" 
            (nzOpenChange)="openHandler('menu1')">
            <nz-select [(ngModel)]="staticdata.display_type" (ngModelChange)="updateStaticData()">
                <nz-option *ngFor="let item of displayType" [nzValue]="item.value" nzLabel="{{ item.title | translate}}"></nz-option>
            </nz-select>

            <div *ngIf="staticdata.display_type == 1 || staticdata.display_type == 3">
                <!-- Nội dung tối thiểu -->
                <div class="config-text" style="width: 100%">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{'noi_dung_toi_thieu' | translate}}</mat-label>
                      <textarea matInput
                        [ngModel]="staticdata['min_content_' + functionService.selectedLanguageCode] | vhLanguage : 'min_content' : objectChoosing.component" 
                        (ngModelChange)="staticdata['min_content_' + functionService.selectedLanguageCode] = $event"  
                        (blur)="updateContent('min_content')"></textarea>
                    </mat-form-field>
                </div>
                <!-- Nội dung tối đa -->
                <div class="config-text" style="width: 100%">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{'noi_dung_toi_da' | translate}}</mat-label>
                      <textarea matInput
                        [ngModel]="staticdata['max_content_' + functionService.selectedLanguageCode] | vhLanguage : 'max_content' : objectChoosing.component" 
                        (ngModelChange)="staticdata['max_content_' + functionService.selectedLanguageCode] = $event"  
                        (blur)="updateContent('max_content')"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </li>
        <!-- Cấu hình khoảng giá -->
        <li nz-submenu nzTitle="{{'tuy_chinh_khoang_gia' | translate}}" [(nzOpen)]="openMap.menu2" 
            (nzOpenChange)="openHandler('menu2')">

            
            <div style="padding-left: 5px;">
                <div class="config-name mb-1">
                    <p class="m-0">{{'toi_thieu' | translate}} </p>
                    <nz-input-number nz-size="12" nz-number placeholder="0" nzSize="large"
                        [(ngModel)]="staticdata.min" (nzBlur)="updateStaticData()" [nzMin]="0"
                         [nzStep]="1">
                    </nz-input-number>
                </div>
                <nz-slider [nzMin]="0"  [ngModel]="staticdata.min | vhnumber" 
                    (nzOnAfterChange)="updateStaticData()" (ngModelChange)="staticdata.min = $event">
                </nz-slider>
            </div>
            <div style="padding-left: 5px;">
                <div class="config-name">
                    <p class="m-0">{{'toi_da' | translate}} </p>
                    <nz-input-number nz-number placeholder="0" nzSize="large"
                        [(ngModel)]="staticdata.max" (nzBlur)="updateStaticData()" [nzMin]="0"
                         [nzStep]="1">
                    </nz-input-number>
                </div>
                <nz-slider [nzMin]="0"  [ngModel]="staticdata.max | vhnumber"
                    (nzOnAfterChange)="updateStaticData()" (ngModelChange)="staticdata.max = $event">
                </nz-slider>
            </div>
            <div class="config-name">
                <p>{{'mau_nen_o_nhap' | translate}}</p>
                <input class="input-color" type="button" 
                    [style.background]="class['range-price__input']['background-color']"
                    [cpOKButton]="true" [(colorPicker)]="class['range-price__input']['background-color']"
                    (colorPickerClose)="updateClass()"/>
            </div>
            <ul nz-menu nzMode="inline" >
                <li nz-submenu nzTitle="{{'dinh_dang_o_nhap' | translate}}">
                    <app-text-format-config
                        [device]="device"
                        [objectChoosing]="objectChoosing"
                        [class]="class"
                        [config]="config"
                        
                        [staticdata]="staticdata"
                        [textContentClass]="class['range-price__input']"
                        [textWrapperClass]="class['range-price__input']"
                    >
                    </app-text-format-config>
                    <ul nz-menu nzMode="inline" >
                        <li nz-submenu nzTitle="{{'dinh_dang_vien_o_nhap' | translate}}">
                            <div class="main-config">
                                <app-borders-config [device]="device"
                                    [class]="class" [elementChoosing]="objectChoosing"
                                    [borderClass]="class['range-price__input']"
                                    [id_object]="objectChoosing._id"
                                >
                                </app-borders-config>
                                
                                <!-- Nút mở rộng -->
                                <div class="config-name view-more-btn mt-2">
                                    <p (click)="openViewAll(stylefields[4])">{{'mo_rong' | translate}} &#8594;</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
        <!-- Cấu hình nút -->
        <li *ngIf="staticdata.display_type==1 || staticdata.display_type==2" nz-submenu nzTitle="{{'tuy_chinh_nut' | translate}}" [(nzOpen)]="openMap.menu5" 
            (nzOpenChange)="openHandler('menu5')">
            <!-- Màu nền nút -->
            <div style="padding-left: 5px;">
                <div class="config-name">
                    <p class="title-font" style="white-space: wrap;"> {{'vi_tri' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100"
                        [ngModel]="class['range-price__button']['left'] | vhnumber"
                        (ngModelChange)="class['range-price__button']['left'] = $event +'%'"
                        (nzBlur)="updateClass()">
                    </nz-input-number>
                </div>
                <nz-row>
                    <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0" [nzMax]="100"
                            [ngModel]="class['range-price__button']['left'] | vhnumber"
                            (ngModelChange)="class['range-price__button']['left'] = $event +'%'"
                            (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                    </nz-col>
                </nz-row>
                <div class="config-name">
                    <p>{{'mau_nen_nut' | translate}}</p>
                    <input class="input-color" type="button"
                        [style.background]="class['range-price__button']['background-color']"
                        [cpOKButton]="true" [(colorPicker)]="class['range-price__button']['background-color']"
                        (colorPickerClose)="updateClass()" />
                </div>
                <ul nz-menu nzMode="inline" >
                    <li nz-submenu nzTitle="{{'kich_thuoc' | translate}}">
                        <div class="button-size">
                            <div class="item-basic">
                                <p class="m-0 title">{{'chieu_cao' | translate}}</p>
                                <nz-input-number [nzMin]="0" [nzMax]="100" style="width:40%"
                                    [ngModel]="class['range-price__button']['height'] | vhnumber" 
                                    (ngModelChange)="class['range-price__button']['height'] = $event + 'px'"
                                    (nzOnAfterChange)="updateClass()"></nz-input-number>
                            </div>
                            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class['range-price__button']['height'] | vhnumber"
                                (nzOnAfterChange)="updateClass()" (ngModelChange)="class['range-price__button']['height'] = $event + 'px'">
                            </nz-slider>
                            <div class="item-basic">
                                <p class="m-0 title">{{'chieu_dai' | translate}}</p>
                                <nz-input-number [nzMin]="0" [nzMax]="100" style="width:40%"
                                    [ngModel]="class['range-price__button']['width'] | vhnumber"
                                    (ngModelChange)="class['range-price__button']['width'] = $event + 'px'"
                                    (nzOnAfterChange)="updateClass()">
                                </nz-input-number>
                            </div>
                            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class['range-price__button']['width'] | vhnumber"
                                (nzOnAfterChange)="updateClass()" (ngModelChange)="class['range-price__button']['width'] = $event + 'px'">
                            </nz-slider>
                        </div>
                    </li>
                    <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}">
                        <app-text-format-config
                                [device]="device"
                                [objectChoosing]="objectChoosing"
                                [class]="class"
                                [config]="config"
                                
                                [staticdata]="staticdata"
                                [textContentClass]="class['range-price__button--text']"
                                [textWrapperClass]="class['range-price__button--text']"
                                >
                        </app-text-format-config>
                    </li>
                    <li nz-submenu nzTitle="{{'dinh_dang_vien_nut' | translate}}">
                        <div class="main-config">
                            <app-borders-config [device]="device"
                                [class]="class" [elementChoosing]="objectChoosing"
                                [borderClass]="class['range-price__button']"
                                [id_object]="objectChoosing._id"
                            >
                            </app-borders-config>
                            <!-- Nút mở rộng -->
                            <div class="config-name view-more-btn">
                                <p (click)="openViewAll(stylefields[0])">{{'mo_rong' | translate}} &#8594;</p>
                            </div>
                        </div>
                    </li>
                    <!-- Bật đổ bóng -->
                    <li nz-submenu nzTitle="{{'do_bong_nut' | translate}}">
                        <app-shadow-config 
                            [device]="device"
                            [config]="config"
                            [class]="class"
                            [shadowClass]="class['range-price__button']"
                            [shadowConfig]="config['shadow_button']"
                            [objectChoosing]="objectChoosing">
                        </app-shadow-config>
                        
                    </li>
                    <!-- Cấu hình biểu tượng -->
                    <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                        <app-symbol-config
                            [device]="device"
                            [class]="class"
                            [config]="config"
                            [symbolClass]="class['range-price__button']"
                            [fontSizeIconClass]="class['range-price__icon']"
                            [symbolConfig]="config['icon_button']"
                            [objectChoosing]="objectChoosing">
                        </app-symbol-config>
                    </li>
                </ul>
            </div>
        </li>
        <!-- Cấu hình tiêu đề -->
        <li *ngIf="staticdata.display_type==1 || staticdata.display_type==3" nz-submenu nzTitle="{{'dinh_dang_tieu_de' | translate}}"[(nzOpen)]="openMap.menu6" 
            (nzOpenChange)="openHandler('menu6')">
            <div class="config-font-size">
                <div class="field-row-font" style="width: 65%">
                    <mat-form-field style="width: 100%">
                        <mat-label>Font</mat-label>
                        <mat-select [(ngModel)]="
                            class['range-price__text']['font-family']
                            " (ngModelChange)="updateClass()" [(value)]="class['range-price__text']['font-family']">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                            font.name
                            }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                    <mat-form-field style="width: 100%">
                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                        <input matInput type="number" [ngModel]="
                            class['range-price__text']['font-size'] | vhnumber
                            " (ngModelChange)="
                            class['range-price__text']['font-size'] =
                                $event + 'px';
                                updateClass()
                            " />
                    </mat-form-field>
                </div>
            </div>
            <div class="container-font">
                <div class="config-font">
                    <p class="title-font">{{'kieu_chu' | translate}}</p>
                    <div class="field-row">
                        <div style="display:flex; width: 80%">
                            <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                                class['range-price__text']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                                (click)="
                                class['range-price__text']['font-weight'] =
                                class['range-price__text']['font-weight'] == 'bold' ? '500' : 'bold';
                                updateClass()">
                                  <span style="font-weight: 600">B</span>
                            </button>
                            <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                    class['range-price__text']['font-style'] == 'italic'
                                    ? 'primary'
                                    : 'default'
                                    " (click)="
                                    class['range-price__text']['font-style'] =
                                    class['range-price__text']['font-style'] == 'normal'
                                        ? 'italic'
                                        : 'normal';
                                    updateClass()">
                                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                            </button>
                            <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                    class['range-price__text']['text-decoration'] ==
                                    'underline'
                                    ? 'primary'
                                    : 'default'
                                " (click)="
                                    class['range-price__text']['text-decoration'] =
                                    class['range-price__text']['text-decoration'] ==
                                    'none'
                                        ? 'underline'
                                        : 'none';
                                    updateClass()">
                                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                            </button>
                            <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                      class['range-price__text']['text-transform'] ==
                                      'uppercase'
                                      ? 'primary'
                                      : 'default'
                                  " (click)="
                                      class['range-price__text']['text-transform'] =
                                      class['range-price__text']['text-transform'] ==
                                      'none'
                                          ? 'uppercase'
                                          : 'none';
                                      updateClass()
                                  ">
                                    <span>AB</span>
                            </button>
                        </div>
                          
                        <div style="width: 15%">
                            <input id="color" type="button"
                            [cpOKButton]="true" [(colorPicker)]="class['range-price__text']['color']"
                            [style.background]="class['range-price__text']['color']"
                            (colorPickerClose)="updateClass()"/>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <!-- Cấu hình thanh trượt -->
        <li nz-submenu nzTitle="{{'cau_hinh_thanh_truot' | translate}}" [(nzOpen)]="openMap.menu3" 
            (nzOpenChange)="openHandler('menu3')">
            <div class="color-pick">
                <span class="title w-50">{{'mau_nut' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="staticdata['background_webkit_slider_thumb']"
                  [style.background]="staticdata['background_webkit_slider_thumb']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" />
            </div>
            <div class="color-pick">
                <span class="title w-50">{{'mau_thanh_truot' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="staticdata['background_moz_range_thumb']"
                  [style.background]="staticdata['background_moz_range_thumb']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" />
            </div>

            <div class="mt-2" style="padding-left: 5px;">
                <div class="config-name mb-1">
                    <p class="m-0">{{'buoc_nhay' | translate}}</p>
                    <nz-input-number nz-size="12" nz-number placeholder="0" 
                        [(ngModel)]="staticdata.step" (ngModelChange)="updateObject()" [nzMin]="0"
                        [nzStep]="1">
                    </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [(ngModel)]="staticdata.step" (nzOnAfterChange)="updateObject()"></nz-slider>
            </div>
        </li>
        <!-- Cấu hình hiển thị các thiết bị -->
        <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu4" 
            (nzOpenChange)="openHandler('menu4')">
            <div class="main-config">
                <!-- Lựa chọn hiển thị cho các thiết bị -->
                <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
                </app-hide-show-config>
            </div>
        </li>
    </ul>
</div>
<div class="editor-content" *ngIf="isViewAll">
    <div class="return" (click)="isViewAll = !isViewAll"
        style="display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-bottom: 5px;"
    >
        <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
        <span (click)="isViewAll = !isViewAll" style="font-weight: 500;">
            {{ currentViewAll.title | translate }}
        </span>
    </div>
</div>
<div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
        <app-borders-radius-config
            [device]="device"
            [class]="class"
            [borderRadiusClass]="class['range-price__button']"
            [id_object]="objectChoosing._id">
        </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền ô nhập-->
    <div class="view_more-border" *ngIf="currentViewAll.index == 5">
        <app-borders-radius-config
            [device]="device"
            [class]="class"
            [borderRadiusClass]="class['range-price__input']"
            [id_object]="objectChoosing._id">
        </app-borders-radius-config>
    </div>
</div>